import { axiosApiInstance } from "../axios";

export async function getExpenseReceiptFile(expenseId: number): Promise<Blob> {
  const response = await axiosApiInstance.get(`expenses/${expenseId}/file`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("authToken")}`,
    },
    responseType: "blob",
  });

  return response.data;
}
